import React from 'react'

function PackingItemHeader() {
    return (
        <thead className='thead-light PackingItemHeader'>
            <tr>
                <th className='Barcode'>Barcode</th>
                <th className='LabelPreview'>SKU</th>
                <th className='TrackingCarrier'>Size</th>
                <th className='CreatedDate'>Tên lô</th>
                <th className='LabelNote'>Thời gian đóng gói</th>
                <th className='LabelType'>Người đóng gói</th>
            </tr>
        </thead>
    )
}

export default PackingItemHeader
